// Consoles/Publications/publications.plugin.js
import supabase from "../../../../../utils/supabase";
import { publicationsColumns } from "./publications.columns";

const publicationsPlugin = {
  // ビューを参照するように変更
  table: "v_publications_with_details",
  
  select: `*`,

  defaultSort: { field: "publication_date", sort: "desc" },

  /**
   * データをv_publications_with_detailsビューから取得します。
   * 結合や複雑なマッピングはバックエンド（ビュー）にオフロードされています。
   */
  async fetch({ page, pageSize, orderBy, ascending, search }) {
    const from = page * pageSize;
    const to = from + pageSize - 1;

    let query = supabase
      .from("v_publications_with_details")
      .select("*", { count: "exact" });

    // 全文検索の実装
    if (search) {
      // ユーザーの入力をftsクエリ用に整形
      const plainQuery = search.trim().replace(/\s+/g, ' & ');
      query = query.textSearch("search_vector", plainQuery);
    }

    // ソート
    // orderBy がビューに存在しないカラムの場合、デフォルトにフォールバック
    try {
      query = query.order(orderBy, { ascending });
    } catch {
      query = query.order("publication_date", { ascending: false });
    }

    // ページネーション
    query = query.range(from, to);

    const { data, error, count } = await query;
    if (error) {
      console.error("Error fetching publications from view:", error);
      throw error;
    }

    // ビューから直接データが来るので、クライアントサイドでのマッピングは最小限
    const rows = data || [];
    const mapped = rows.map(publicationsPlugin.normalize);
    return { rows: mapped, total: count || 0 };
  },

  /**
   * ビューから取得したデータをフロントエンドで扱いやすいように最終調整します。
   * 主なロジックはビュー側にあるため、ここではごく僅かな処理に留まります。
   */
  normalize(row) {
    // authorsとauthors_textはビューから直接提供される
    const authors = row.authors || [];
    const authors_text = row.authors_text || "";

    return {
      ...row,
      authors, // JSON配列
      authorsText: authors_text, // 整形済みテキスト
      // HTML表示用のプロパティ
      titleEnglishHtml: row.title_english || "",
      titleOriginalHtml: row.title_original || "",
      // テキスト検索用のプロパティは不要になった
      journalName: row.journal_name || "",
    };
  },
  
  columns: publicationsColumns,
};

export default publicationsPlugin;
export { publicationsPlugin };
